/**
 * `<ConsoleHome>` — admin-host root route (`/`).
 *
 * The cockpit is now the canonical console entry point. The redirect lives
 * in `router.ts::consoleHomeRoute.beforeLoad`; this component remains as a
 * minimal fallback for the static route shell.
 */
export function ConsoleHome() {
  return null
}
